import type { ReactNode } from "react"
import { Navigate, useLocation } from "react-router"

import { FullPageLoader } from "@/components/kit/FullPageLoader"
import { hasSessionHint } from "./session-hint"
import { useSession } from "./session"

/**
 * The "must be signed in at all" gate around the shell (LLD §6.3, §11.1).
 * Permissions are `RequirePermission`'s (Task 1.4).
 *
 * While the bootstrap refresh is out it holds what index.html painted: with
 * the boot hint, the shell's loader, the same pixels as the static skeleton;
 * without it, nothing, so the static sign-in copy stays up until the
 * redirect replaces it with the real screen (the LCP stays the static paint,
 * NFR-DSH-01).
 */
export function RequireSession({ children }: { children: ReactNode }) {
  const { state } = useSession()
  const location = useLocation()

  if (state === "pending") return hasSessionHint() ? <FullPageLoader /> : null
  if (state === "anonymous") {
    const from = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/sign-in?from=${from}`} replace />
  }
  return <>{children}</>
}
